<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <SponsorshipListPanel :portal="portal" :content-topic="contentTopic"/>

      <ArticleListPanel :portal="portal" :content-topic="contentTopic"/>

      <FormPanel
          :initial="contentTopic.attributes"
          headline="Edit Topic"
          :errors="errors"
          :portal="portal"
          :edit="true"
          @submit="submit"
      />

      <GridPanel
          :url="'/api/v2/content-topics/' + $route.params.contentTopicId + '/content-rows'"
          :portal="portal"
          @create-content-block="$router.push('content-rows/'+$event.id+'/content-blocks/create')"
          @edit-content-block="$router.push('content-rows/'+$event.contentRow.id+'/content-blocks/'+$event.contentBlock.id+'/edit')"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentTopics/Panels/Form'
import ArticleListPanel from '../../../../../../../components/Administration/ContentTopicArticles/Panels/List'
import SponsorshipListPanel from '../../../../../../../components/Administration/ContentTopicSponsorships/Panels/List'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'
import GridPanel from "../../../../../../../components/Administration/ContentRows/Panels/Grid.vue";

export default {
  components: {ArticleListPanel, LoadingContainer, FormPanel, SponsorshipListPanel,GridPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      contentTopic: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-topics/' + this.$route.params.contentTopicId).then(response => {
        this.contentTopic = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-topics/' + this.$route.params.contentTopicId, data)
          .then(() => {
            notify.success('The content topic was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/topics')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
